export function generateId() {
    return `${Date.now()}${Math.ceil(Math.random() * 1000000)}`;
}
